import { TaskListService } from '@alfresco/adf-process-services';
import {
  ResultListDataRepresentationTaskRepresentation,
  TaskQueryRepresentation,
  TaskRepresentation,
} from '@alfresco/js-api';
import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  TaskListDefinitionDataModelResponse,
  TaskReassigBulkRequestModel,
  TaskReassignBulkResponseModel,
} from '../components/shared/models';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';

@Injectable({
  providedIn: 'root',
})
export class WkTaskListService {
  private readonly contentType = ['application/json'];

  constructor(
    private readonly taskListService: TaskListService,
    private readonly apiService: WkAlfrescoApiService
  ) {}

  public assignTask(
    taskId: string,
    requestNode: any
  ): Observable<TaskRepresentation> {
    return this.taskListService.assignTask(taskId, requestNode);
  }

  public getTasks(
    requestNode: TaskQueryRepresentation
  ): Observable<ResultListDataRepresentationTaskRepresentation> {
    return this.taskListService.getTasks(requestNode);
  }

  public claimTask(taskId: string): Observable<TaskRepresentation> {
    return this.taskListService.claimTask(taskId);
  }

  public getTasksDataSteps(
    taskList: string[]
  ): Observable<TaskListDefinitionDataModelResponse> {
    return from(
      this.apiService.callProcessClientCustomApi({
        path: 'activiti-app/api/enterprise/wk/getStepDetails',
        httpMethod: 'POST',
        bodyParam: { taskIds: taskList },
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    ).pipe(catchError((error) => throwError(() => error)));
  }

  public setTaskReassignmentBulk(
    bulkTaskList: TaskReassigBulkRequestModel
  ): Observable<TaskReassignBulkResponseModel> {
    return from(
      this.apiService.callProcessClientCustomApi({
        path: 'activiti-app/api/enterprise/wk/reassign',
        httpMethod: 'POST',
        bodyParam: bulkTaskList,
        contentTypes: this.contentType,
        accepts: this.contentType,
      })
    ).pipe(catchError((error) => throwError(() => error)));
  }
}
